import * as Actions from "./constants";
const initialState = {
  orderResponse: "",
};

export default function subscriptionPlanReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SUBSCRIPTION:
      return {
        ...state,
      };
    case Actions.GET_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptions: action.payload,
      };
    case Actions.GET_SUBSCRIPTION_FAIL:
      return {
        ...state,
        error: action.error,
      };
    case Actions.GET_SUBSCRIPTION_BY_ID:
      return {
        ...state,
      };
    case Actions.GET_SUBSCRIPTION_BY_ID_SUCCESS:
      return {
        ...state,
        subscription: action.payload,
      };
    case Actions.GET_SUBSCRIPTION_BY_ID_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case Actions.CREATE_ORDER:
      return {
        ...state,
      };
    case Actions.CREATE_ORDER_SUCCESS:
      return {
        ...state,
        orderResponse: action.payload,
      };
    case Actions.CREATE_ORDER_ERROR:
      return {
        ...state,
        orderError: action.payload,
      };
    case Actions.PAYMENT_INTENT:
      return {
        ...state,
      };
    case Actions.PAYMENT_INTENT_SUCCESS:
      return {
        ...state,
        clientSecret: action.payload,
      };
    case Actions.PAYMENT_INTENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case Actions.GET_PRICE_BY_ID:
      return {
        ...state,
      };
    case Actions.GET_PRICE_BY_ID_SUCCESS:
      return {
        ...state,
        priceData: action.payload,
      };
    case Actions.GET_PRICE_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
